import { Box, Typography } from "@material-ui/core";
import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { BasicButton } from "../../../components/Primitives/Buttons";
import { useAuthContext } from "../../../providers/Auth/auth.provider";
import { useLoginAs } from "../../../providers/Auth/login-as-context";
import DefaultLayout from "../../layout/default.layout";

interface IMaintenanceModePageProps {
  description?: string;
}

export const MaintenanceModePage: FC<IMaintenanceModePageProps> = ({ description }) => {
  const { t } = useTranslation();
  const { logout, logoutAs } = useAuthContext();
  const { loggedAs } = useLoginAs();
  const [isProcessing, setIsProcessing] = useState(false);

  // in a Login-As session, the admin returns to the own account (admins are not blocked by the maintenance mode)
  const handleLogout = async () => {
    setIsProcessing(true);
    try {
      await (loggedAs ? logoutAs() : logout());
    } catch {
      // errors are reported by the global query error handling; on success the page is unmounted
      setIsProcessing(false);
    }
  };

  return (
    <DefaultLayout>
      <Box height="100%" display="flex" flexDirection="column" alignItems="center">
        <h1>{t("maintainance.title")}</h1>
        <Typography>
          <p>Sehr geehrte Nutzerinnen und Nutzer des GRS-Portals,</p>
          <p>wir möchten Sie darüber informieren, dass aufgrund von <b>planmäßigen Wartungsarbeiten</b> das GRS-Portal voraussichtlich bis <b>{description}</b> nicht verfügbar sein wird.</p>
          <p>Für dringende Anliegen bitten wir Sie, unser Service-Center zu kontaktieren:
            <ul>
              <li>
                <b>E-Mail</b>: portal@grs-batterien.de
              </li>
              <li>
                <b>Service Center Telefonnummer</b>: +49 1806 80 50 30*
              </li>
              <li>
                <b>Servicezeiten</b>: Montag bis Donnerstag von 9:00 bis 12:00 Uhr und von 13:00 bis 16:00 Uhr, sowie Freitag von 9:00 bis 13:00 Uhr.
              </li>
            </ul>
          </p>
          <p>
            <i>
              *Festnetzpreis: 20 Cent pro Anruf; Mobilfunkpreise: maximal 60 Cent pro Anruf.
            </i>
          </p>
          <p>Wir danken Ihnen für Ihr Verständnis und stehen Ihnen bei weiteren Fragen gerne zur Verfügung.</p>
          <p>Mit freundlichen Grüßen,<br></br>Ihr GRS-Team</p>
        </Typography>
        <Box mt={2}>
          <BasicButton onClick={handleLogout} disabled={isProcessing} id="maintenanceModeLogoutButton">
            {loggedAs ? t("maintainance.logout_as") : t("maintainance.logout")}
          </BasicButton>
        </Box>
      </Box>
    </DefaultLayout>
  );
};
